"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _queryString = require("query-string");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DesktopAppInstallerUrl = /*#__PURE__*/function () {
  function DesktopAppInstallerUrl(baseUrl) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        trackingCid = _ref.trackingCid,
        gaId = _ref.gaId,
        satuId = _ref.satuId,
        campaign = _ref.campaign;

    (0, _classCallCheck2.default)(this, DesktopAppInstallerUrl);
    (0, _defineProperty2.default)(this, "installerUrl", void 0);
    var url = new URL(baseUrl);
    var urlSearchParams = (0, _queryString.parse)(url.search);
    url.search = (0, _queryString.stringify)(_objectSpread(_objectSpread({}, urlSearchParams), {}, {
      // replaced with ga but still here to keep backward compatibility
      cid: trackingCid,
      ga: gaId,
      satu: satuId,
      campaign: campaign
    }));
    this.installerUrl = url.href;
  }

  (0, _createClass2.default)(DesktopAppInstallerUrl, [{
    key: "toString",
    value: function toString() {
      return this.installerUrl;
    }
  }]);
  return DesktopAppInstallerUrl;
}();

var _default = DesktopAppInstallerUrl;
exports.default = _default;
//# sourceMappingURL=desktop-app-installer-url.js.map